import React from 'react';
import { BellIcon, MessageSquareIcon, CalendarIcon } from 'lucide-react';
import { PageHeader } from '../components/common/PageHeader';
const notifs = [{
  id: '1',
  type: 'system',
  title: '系统通知',
  desc: '您的 AI 选校报告已生成，点击查看。',
  time: '10 分钟前',
  icon: BellIcon,
  color: 'bg-blue-50 text-blue-600'
}, {
  id: '2',
  type: 'comment',
  title: '互动消息',
  desc: '小红 赞了你的评论。',
  time: '2 小时前',
  icon: MessageSquareIcon,
  color: 'bg-emerald-50 text-emerald-600'
}, {
  id: '3',
  type: 'appointment',
  title: '预约提醒',
  desc: '您预约的【指南者留学】咨询将在明天 14:00 开始。',
  time: '昨天',
  icon: CalendarIcon,
  color: 'bg-amber-50 text-amber-600'
}];
export function Notifications() {
  return <div className="bg-slate-50 min-h-screen pb-10" data-id="element-575">
      <PageHeader title="消息通知" data-id="element-576" />
      <div className="p-3 space-y-2" data-id="element-577">
        {notifs.map(n => {
        const Icon = n.icon;
        return <div key={n.id} className="bg-white rounded-2xl p-4 flex gap-3" data-id="element-578">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${n.color}`} data-id="element-579">
                <Icon size={20} data-id="element-580" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-581">
                <div className="flex items-center justify-between mb-1" data-id="element-582">
                  <div className="font-bold text-slate-800 text-sm" data-id="element-583">
                    {n.title}
                  </div>
                  <div className="text-[10px] text-slate-400" data-id="element-584">{n.time}</div>
                </div>
                <div className="text-xs text-slate-600 leading-relaxed" data-id="element-585">
                  {n.desc}
                </div>
              </div>
            </div>;
      })}
      </div>
    </div>;
}